import { Component } from '@angular/core';

@Component({
  selector: 'app-setting-view',
  standalone: true,
  imports: [],
  templateUrl: './setting-view.component.html',
  styleUrl: './setting-view.component.scss'
})
export class SettingViewComponent {

}
